import { useSessionStorage } from '@web/hooks/session-storage';

import { SESSION_ID_KEY } from '../constants/session-id-key';

export function useSessionId() {
  const [sessionToken, setSessionToken] = useSessionStorage(SESSION_ID_KEY);

  return [sessionToken, setSessionToken] as const;
}
